import { render, staticRenderFns } from "./danCiSuJi.vue?vue&type=template&id=7fa8187e&scoped=true&"
import script from "./danCiSuJi.vue?vue&type=script&lang=js&"
export * from "./danCiSuJi.vue?vue&type=script&lang=js&"
import style0 from "./danCiSuJi.vue?vue&type=style&index=0&id=7fa8187e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa8187e",
  null
  
)

export default component.exports